// src/pages/Training.jsx
import { useState } from 'react';
import DashboardLayout from '../components/layout/DashboardLayout';
import { C } from '../styles/tokens';

const COURSES = [
  { id:1, title:'React Advanced Patterns',  cat:'Engineering', dur:'12h', level:'Advanced',     price:30,  rating:4.9, enrolled:1240, badge:'⚛️',  progress:65,  status:'in-progress' },
  { id:2, title:'Solana Smart Contracts',   cat:'Blockchain',  dur:'18h', level:'Advanced',     price:50,  rating:4.8, enrolled:860,  badge:'⛓️', progress:0,   status:'available'   },
  { id:3, title:'Product Design Mastery',   cat:'Design',      dur:'8h',  level:'Intermediate', price:25,  rating:4.7, enrolled:3200, badge:'🎨',  progress:100, status:'completed'   },
  { id:4, title:'AI for Product Managers',  cat:'Product',     dur:'10h', level:'Intermediate', price:35,  rating:4.8, enrolled:2100, badge:'🤖',  progress:0,   status:'available'   },
  { id:5, title:'Web3 Fundamentals',        cat:'Blockchain',  dur:'6h',  level:'Beginner',     price:0,   rating:4.6, enrolled:5400, badge:'🌐',  progress:100, status:'completed'   },
  { id:6, title:'Data Science with Python', cat:'Engineering', dur:'20h', level:'Intermediate', price:45,  rating:4.7, enrolled:1800, badge:'🐍',  progress:0,   status:'available'   },
];

const CERTS = [
  { name:'Web3 Fundamentals',     date:'Dec 2024', id:'ON-CERT-001', hash:'0x3f...a9' },
  { name:'Product Design Mastery',date:'Jan 2025', id:'ON-CERT-002', hash:'0x7c...b2' },
];

const CATS   = ['All','Engineering','Design','Blockchain','Product'];
const STATUS = ['All','In Progress','Completed','Available'];
const levelColor = { Beginner:C.success, Intermediate:C.info, Advanced:C.magenta };

export default function Training() {
  const [cat,    setCat]    = useState('All');
  const [status, setStatus] = useState('All');
  const [tab,    setTab]    = useState('courses');

  const filtered = COURSES.filter(c => {
    const matchCat    = cat === 'All' || c.cat === cat;
    const matchStatus = status === 'All'
      || (status === 'In Progress' && c.status === 'in-progress')
      || (status === 'Completed'   && c.status === 'completed')
      || (status === 'Available'   && c.status === 'available');
    return matchCat && matchStatus;
  });

  return (
    <DashboardLayout title="Training Hub" subtitle="Earn certified credentials that live on the blockchain">
      <style>{`
        .training-stats {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 14px;
          margin-bottom: 20px;
        }
        .training-filters {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          margin-bottom: 20px;
        }
        @media (max-width: 700px) {
          .training-stats { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 400px) {
          .training-stats { grid-template-columns: 1fr !important; }
        }
      `}</style>

      {/* Stats */}
      <div className="training-stats">
        {[['🎓','Enrolled','3',C.magenta],['✅','Completed','2',C.success],['🏅','Certificates','2',C.warning],['⏱️','Hours Learned','26h',C.violet]].map(([i,l,v,c]) => (
          <div key={l} className="card" style={{ padding:'18px 20px' }}>
            <div style={{ position:'absolute', top:0, left:0, right:0, height:2, background:`linear-gradient(90deg,${c}70,transparent)` }} />
            <span style={{ fontSize:22 }}>{i}</span>
            <div className="syne" style={{ fontSize:'clamp(20px,4vw,26px)', fontWeight:800, color:c, marginTop:8 }}>{v}</div>
            <div style={{ fontSize:12, color:'rgba(255,255,255,.5)', fontWeight:600 }}>{l}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {[['courses','📚 Courses'],['certs','🏅 Certificates']].map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} style={{ padding:'10px 22px', borderRadius:9, background: tab===k ? `linear-gradient(135deg,${C.magenta},${C.violet})` : 'rgba(255,255,255,.05)', border: tab===k ? 'none' : '1px solid rgba(255,255,255,.1)', color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'Syne',sans-serif" }}>{l}</button>
        ))}
      </div>

      {tab === 'courses' && (
        <>
          {/* Filters */}
          <div className="training-filters">
            {CATS.map(c => <button key={c} onClick={() => setCat(c)} style={{ padding:'7px 14px', borderRadius:100, background: cat===c ? `linear-gradient(135deg,${C.magenta},${C.violet})` : 'rgba(255,255,255,.05)', border: cat===c ? 'none' : '1px solid rgba(255,255,255,.1)', color:'#fff', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:"'Syne',sans-serif" }}>{c}</button>)}
            <div style={{ width:1, background:'rgba(255,255,255,.1)', margin:'0 2px' }} />
            {STATUS.map(s => <button key={s} onClick={() => setStatus(s)} style={{ padding:'7px 14px', borderRadius:100, background: status===s ? `rgba(95,8,231,.3)` : 'rgba(255,255,255,.03)', border: status===s ? `1px solid rgba(95,8,231,.5)` : '1px solid rgba(255,255,255,.08)', color: status===s ? '#fff' : 'rgba(255,255,255,.5)', fontSize:12, fontWeight:600, cursor:'pointer' }}>{s}</button>)}
          </div>

          {/* Course grid */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(min(280px,100%),1fr))', gap:16 }}>
            {filtered.map(c => (
              <div key={c.id} className="card" style={{ padding:22, cursor:'pointer', transition:'all .25s' }}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.borderColor='rgba(254,52,232,.3)'; e.currentTarget.style.boxShadow='0 16px 48px rgba(95,8,231,.2)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.borderColor='rgba(254,52,232,.1)'; e.currentTarget.style.boxShadow='none'; }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:14 }}>
                  <div style={{ width:52, height:52, borderRadius:13, background:'rgba(255,255,255,.06)', border:'1px solid rgba(255,255,255,.08)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:26 }}>{c.badge}</div>
                  <span style={{ fontSize:11, padding:'3px 9px', borderRadius:100, background:`${levelColor[c.level]}15`, color:levelColor[c.level], fontWeight:700 }}>{c.level}</span>
                </div>
                <h3 className="syne" style={{ fontSize:15, fontWeight:700, marginBottom:6 }}>{c.title}</h3>
                <div style={{ fontSize:12, color:'rgba(255,255,255,.4)', marginBottom:14 }}>{c.cat} · {c.dur} · ⭐ {c.rating} · {c.enrolled.toLocaleString()} enrolled</div>
                {c.status === 'in-progress' && (
                  <div style={{ marginBottom:14 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                      <span style={{ fontSize:11, color:'rgba(255,255,255,.45)' }}>Progress</span>
                      <span style={{ fontSize:11, fontWeight:700, color:C.magenta }}>{c.progress}%</span>
                    </div>
                    <div style={{ height:5, borderRadius:3, background:'rgba(255,255,255,.07)' }}>
                      <div style={{ height:'100%', width:`${c.progress}%`, background:`linear-gradient(90deg,${C.magenta},${C.violet})`, borderRadius:3 }} />
                    </div>
                  </div>
                )}
                {c.status === 'completed' && (
                  <div style={{ padding:'8px 12px', borderRadius:8, background:'rgba(0,208,132,.08)', border:'1px solid rgba(0,208,132,.2)', marginBottom:14 }}>
                    <span style={{ fontSize:12, color:C.success, fontWeight:600 }}>✅ Completed · Certificate Issued</span>
                  </div>
                )}
                <button style={{ width:'100%', padding:'11px', background: c.status==='completed' ? 'rgba(255,255,255,.05)' : `linear-gradient(135deg,${C.magenta},${C.violet})`, border: c.status==='completed' ? '1px solid rgba(255,255,255,.1)' : 'none', borderRadius:9, color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'Syne',sans-serif" }}>
                  {c.status==='in-progress' ? 'Continue →' : c.status==='completed' ? 'View Certificate' : `Enroll${c.price>0 ? ` — ${c.price} ONT` : ' — Free'}`}
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      {tab === 'certs' && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(min(320px,100%),1fr))', gap:16 }}>
          {CERTS.map((cert, i) => (
            <div key={i} className="card" style={{ padding:'clamp(20px,4vw,28px)', background:`linear-gradient(135deg,${C.navy}60,${C.violet}30)` }}>
              <div style={{ position:'absolute', top:0, left:0, right:0, height:3, background:`linear-gradient(90deg,${C.magenta},${C.violet})` }} />
              <div style={{ fontSize:40, marginBottom:14 }}>🏅</div>
              <h3 className="syne" style={{ fontSize:18, fontWeight:800, marginBottom:4 }}>{cert.name}</h3>
              <p style={{ fontSize:13, color:'rgba(255,255,255,.45)', marginBottom:18 }}>Issued: {cert.date} · ID: {cert.id}</p>
              <div style={{ padding:'10px 14px', borderRadius:9, background:'rgba(0,0,0,.25)', fontFamily:'monospace', fontSize:12, color:'rgba(255,255,255,.5)', marginBottom:18, wordBreak:'break-all' }}>
                Blockchain Hash: {cert.hash}...verified ✅
              </div>
              <div style={{ display:'flex', gap:10 }}>
                <button style={{ flex:1, padding:'10px', background:`linear-gradient(135deg,${C.magenta},${C.violet})`, border:'none', borderRadius:8, color:'#fff', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:"'Syne',sans-serif" }}>Download PDF</button>
                <button style={{ flex:1, padding:'10px', background:'rgba(255,255,255,.05)', border:'1px solid rgba(255,255,255,.1)', borderRadius:8, color:'#fff', fontSize:12, fontWeight:600, cursor:'pointer' }}>Share Link</button>
              </div>
            </div>
          ))}
          <div className="card" style={{ padding:'clamp(20px,4vw,28px)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', textAlign:'center', border:'2px dashed rgba(254,52,232,.2)', minHeight:200 }}>
            <div style={{ fontSize:36, marginBottom:12 }}>🎓</div>
            <h3 className="syne" style={{ fontSize:15, fontWeight:700, marginBottom:6 }}>Earn More Certificates</h3>
            <p style={{ fontSize:13, color:'rgba(255,255,255,.4)', marginBottom:16 }}>Complete courses to earn blockchain-verified credentials</p>
            <button onClick={() => setTab('courses')} style={{ padding:'10px 20px', background:`linear-gradient(135deg,${C.magenta},${C.violet})`, border:'none', borderRadius:8, color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'Syne',sans-serif" }}>Browse Courses →</button>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
